export default "__VITE_ASSET__CejyIpPI__"